export const SET_MONEY = 'payment/SET_MONEY';
export const ADD_MONEY = 'payment/ADD_MONEY';
export const FETCH_PAYMENT_OPTIONS = 'payment/FETCH_PAYMENT_OPTIONS';
export const RESET_PAYMENT = 'payment/RESET_PAYMENT';
export const SET_PAYMENT_OPTIONS = 'payment/SET_PAYMENT_OPTIONS';
export const GET_CARD_TYPE = 'payment/GET_CARD_TYPE';
export const VERIFY_UPI = 'payment/VERIFY_UPI';
export const UPDATE_TRANSACTION = 'payment/UPDATE_TRANSACTION';
export const PROCESS_TRANSACTION = 'payment/PROCESS_TRANSACTION';
export const FETCH_NB_OPTIONS = 'payment/FETCH_NB_OPTIONS';
export const FETCH_PAYMENT_RESPONSE = 'payment/FETCH_PAYMENT_RESPONSE';

export const cardMapping: any = {
  DEBIT_CARD: 'DC',
  CREDIT_CARD: 'CC',
};
